import { render, staticRenderFns } from "./modalCategoriasComprar.vue?vue&type=template&id=985c5dfc&"
import script from "./modalCategoriasComprar.vue?vue&type=script&lang=js&"
export * from "./modalCategoriasComprar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports